import ASSIGNMENTS_SELECTOR_TABS from '../../models/assignmentsTabs.js';
import assignmentsUnassignedComponent from './../assignmentsUnassigned/assignmentsUnassigned.component';
import SORT from '../../models/sort.js';
import _ from 'lodash';
import moment from 'moment';

class AssignmentsController {
  constructor(modalLoaderService, $state, entitlerService, $translate, $scope, localStorageService, $q, assignmentsService) {
    this.localStorageService = localStorageService;
    this.isImpersonating = this.localStorageService.get('isImpersonating');
    this.userId = this.isImpersonating ? this.localStorageService.get('impersonatingCustomer').id : this.localStorageService.get('user').customerId;
    this.persistStudentValue = [];
    this.name = 'assignments';
    this.$state = $state;
    this.$scope = $scope;
    this.$q = $q;
    this.$translate = $translate;
    this.entitlerService = entitlerService;
    this.modalLoaderService = modalLoaderService;
    this.tabs = ASSIGNMENTS_SELECTOR_TABS;
    this.ROWS_PER_PAGE = 200;
    this.sort = SORT;
    this.selectedValues = [];
    this.createValues = [];
    this.deleteValues = [];
    this.deletedAssignments = [];
    this.schoolList = [];
    this.tabName = this.tabs[0].options.tabName;
    this.assignmentsService = assignmentsService;
    this.setTabDefaults();
    this.activateTab(this.tabName);
    $scope.$watchCollection(() => this.selectedValues, this.updateChangedAndSelected.bind(this));
    this.checkboxChange();
  }

  checkboxChange() {
    const checkboxEvent = this.$scope.$on('checkboxChange', (event, data) => {
      if (data.isChecked === false){
        this.metaData.entitler.rowIds = this.metaData.entitler.rowIds.filter(id => id !== data.checklistValue);
      }
    });
    this.$scope.$on('$destroy', function() {
      checkboxEvent();
    });
  }

  hasNoSelections() {
    return !this.hasSelections;
  }

  fetchOrgForCustomer() {
    const isImpersonating = this.localStorageService.get('isImpersonating');
    const customerId = isImpersonating ? this.localStorageService.get('impersonatingCustomer').id : this.localStorageService.get('user').customerId;
    let deferred = this.$q.defer();
    this.entitlerService.getOrgsByType(customerId, 'school').then(schoolList => {
      this.metaData.entitler.schoolList = schoolList.data.content;
      this.schoolList = schoolList.data.content;
      deferred.resolve(schoolList.data.content);
    });

    return deferred.promise;
  }

  getTabsForNoneConnectedProducts() {
    return ASSIGNMENTS_SELECTOR_TABS.filter(function (item) {
      return item.options.tabName !== 'users';
    });
  }

  setActiveTabFromClick() {
    if (this.tabName !== this.activeTab.options.tabName) {
      if (this.createValues.length > 0 || this.deleteValues.length > 0) {
        this.modalLoaderService.show(assignmentsUnassignedComponent, {
          onConfirmation: this.switchTab.bind(this),
          onCancel: this.resetTab.bind(this)
        }, 'assingment-unassigned__modal');
      } else {
        this.switchTab();
      }
    }
  }

  cleanSchoolMapping() {
    for (var key in this.metaData) {
      if (this.metaData[key] && this.metaData[key].schoolMappingCreated) {
        this.metaData[key].schoolMappingCreated = {};
      }

      if (this.metaData[key] && this.metaData[key].schoolMappingDeleted) {
        this.metaData[key].schoolMappingDeleted = {};
      }

    }
  }

  clearSearchValues() {
    for (var key in this.metaData) {
      if (this.metaData[key] && this.metaData[key].search) {
        this.metaData[key].search.value = '';
      }
    }
  }

  resetTab() {
    this.tabName = this.activeTab.options.tabName;
  }

  doesEntitlerHaveSelectedResources() {
    return !_.isEmpty(this.entitler.selectedResources);
  }

  // doesEntitlerHaveSelectedResources() above only guarantees
  // selectedResources is a non-empty *something* per lodash's _.isEmpty
  // (e.g. a non-empty plain object or string would also pass it), so the
  // previous direct reads of `selectedResources[0].id` at the call sites
  // below could throw if selectedResources were ever null, not an array,
  // or contained a null/undefined first entry. This defensively checks
  // for a real array with a real first entry before reading `.id`,
  // returning null instead of throwing otherwise.
  //
  // Note: we intentionally do NOT call doesEntitlerHaveSelectedResources()
  // here first - it would be redundant (the Array.isArray/length check
  // below already covers everything it checks, and more), and it reads
  // `this.entitler.selectedResources` without the `this.entitler &&` guard
  // used below, so calling it before that guard could itself throw if
  // `this.entitler` were ever null/undefined - reintroducing the exact
  // crash this helper exists to prevent.
  getSelectedResourceId() {
    const selectedResources = this.entitler && this.entitler.selectedResources;
    if (!Array.isArray(selectedResources) || !selectedResources.length) {
      return null;
    }
    const firstResource = selectedResources[0];
    return (firstResource && firstResource.id) || null;
  }

  doesEntitlerHaveSelectedAleksMasterTemplate() {
    return !_.isEmpty(this.entitler.selectedAleksMasterTemplate);
  }

  isSelectedProductCategorySecondary() {
    const selectedProducts = this.entitler.selectedProducts;
    return selectedProducts.length > 0 ? (selectedProducts[0].productCategory === 'secondary' ? true : false) : false;
  }

  isConnectEdProduct() {
    const selectedProducts = this.entitler.selectedProducts;
    return selectedProducts.length > 0 ? (_.toLower(selectedProducts[0].platform) === 'connected' || selectedProducts[0].platform === null) ? true : false : false;
  }

  isManagedLicensesEnabled(){
    const licensingType = this.localStorageService.get('licensingType');
    return licensingType && licensingType.toLowerCase() === 'directlicensing' && this.isConnectEdProduct() || false;
  }

  initializAssignments() {
    if (this.entitler.selectedProducts && this.entitler.selectedProducts.length === 0) {
      this.goToPreviousState();
    } else {
      this.switchTab();
    }
  }

  switchTab() {
    angular.copy([], this.createValues);
    angular.copy([], this.deleteValues);
    angular.copy([], this.selectedValues);
    this.activateTab(this.tabName);
    this.setTabDefaults();
    this.toggleSort('name', false);
    this.$state.go(this.$state.current, {
      tabName: this.tabName
    }, {
      notify: false,
      reload: this.$state.current
    });
  }

  activateTab(tabName) {
    let activeTabIndex = _.findIndex(this.tabs, (tab) => {
      return tab.options.tabName === tabName;
    });
    this.activeTab = this.tabs[activeTabIndex];
    this.activeTab.options.active = true;
  }

  setTabDefaults() {
    this.hasSelections = true;
    this.searchValue = '';
    this.clearSearchValues();
    this.cleanSchoolMapping();
    this.offset = 0;
    this.sortBy = {
      column: 'name',
      order: this.sort.ascending
    };
    this.data = {};
    this.previousData = {
      content: []
    };
  }

  fetchDataForActiveTab(offset, tabName) {
    const sortBy = this.sortBy;
    const limit = this.ROWS_PER_PAGE;
    const searchValue = this.searchValue;
    const productAssignmentId = this.entitler.selectedProducts.length !== 0 ? [this.entitler.selectedProducts[0].id] : null;
    // switched from `this.doesEntitlerHaveSelectedResources() ?
    // [this.entitler.selectedResources[0].id] : null` to getSelectedResourceId()
    // to avoid a possible crash if selectedResources were ever null, not an
    // array, or had a null/undefined first entry.
    const selectedResourceId = this.getSelectedResourceId();
    const enterpriseResourceId = selectedResourceId ? [selectedResourceId] : null;
    const aleksMasterTemplateId = this.doesEntitlerHaveSelectedAleksMasterTemplate() ? this.entitler.selectedAleksMasterTemplate[0].aleksMasterTemplateId : null;
    const isSecondaryProduct = this.isSelectedProductCategorySecondary();
    const isConnectEdProduct = this.isConnectEdProduct();
    const manageLicenses = this.isManagedLicensesEnabled();

    if (productAssignmentId) {
      this.fetchDataForCustomer(offset, tabName, sortBy, limit, searchValue, productAssignmentId, enterpriseResourceId, aleksMasterTemplateId, isSecondaryProduct, isConnectEdProduct, manageLicenses);
    }
  }

  fetchDataForCustomer(offset, tabName, sortBy, limit, searchValue, productAssignmentId, enterpriseResourceId, aleksMasterTemplateId, isSecondaryProduct, isConnectEdProduct, manageLicenses) {
    this.entitlerService.fetchDataByCustomer(offset, tabName, sortBy, limit, searchValue, productAssignmentId, enterpriseResourceId, aleksMasterTemplateId, isSecondaryProduct, isConnectEdProduct, manageLicenses)
      .then(this.onRequestRetrievalSuccess.bind(this), this.onRequestRetrievalFailure.bind(this));

  }

  checkForSchoolFilterUpdates() {
    return (this.tabName === 'courses' && (_.size(this.metaData.entitler.schoolMappingCreated) > 0 || _.size(this.metaData.entitler.schoolMappingDeleted) > 0));
  }

  getEnabledSchoolIds(courseId) {
    // Prefer the ids cached by the dropdown when it built this row's school
    // list — this stays correct even if the row has since fallen out of the
    // currently loaded page (e.g. after a search or sort reload).
    const cachedIds = this.metaData.entitler.rowEnabledSchoolIds &&
      this.metaData.entitler.rowEnabledSchoolIds[courseId];
    if (Array.isArray(cachedIds)) {
      return cachedIds;
    }

    const schoolsById = _.keyBy(this.schoolList, 'id');
    const allSchoolIds = _.map(this.schoolList, 'id');
    const row = (this.data && this.data.content || []).find(item => item.id === courseId);
    if (!row || !(row.isSecondaryProduct && !row.isConnectEdProduct)) {
      return allSchoolIds;
    }
    // Mirrors TableGridDropdownCellController.getEligibleSchoolIds() so both
    // sides of the "all schools" decision use identical criteria.
    const enabledIds = _.uniq(row.schoolIdsfromProductAssociation || []);
    if (enabledIds.length === 0 && row.allSchoolsfromProductAssociation) {
      return allSchoolIds;
    }
    return enabledIds.filter(id => schoolsById[id]);
  }

  getEnabledSchoolCount(courseId) {
    return this.getEnabledSchoolIds(courseId).length;
  }

  // "All schools" must mean the selection actually covers every enabled school,
  // not merely that the two lists happen to be the same length. Comparing
  // lengths lets a set of legacy/disabled schools collide with the enabled
  // count and wrongly assign or unassign schools the admin never touched.
  coversAllEnabledSchools(courseId, schoolIds) {
    const enabledIds = this.getEnabledSchoolIds(courseId);
    if (enabledIds.length === 0) {
      // Only a customer with no schools at all can be "all schools" here; a
      // restricted row with no eligible schools must stay an explicit list.
      return this.schoolList.length === 0;
    }
    return _.difference(enabledIds, schoolIds).length === 0;
  }

  buildSchoolAssignments () {
    const assignedSchools = _.keys(this.metaData.entitler.schoolMappingCreated);
    const unAssignedSchools = _.keys(this.metaData.entitler.schoolMappingDeleted);
    const {
      assignSchools,
      assignAllSchools,
    } = _.reduce(assignedSchools, (acc, courseId) => {
      const schoolsAssigned = this.metaData.entitler.schoolMappingCreated[courseId] || [];
      if (this.coversAllEnabledSchools(courseId, schoolsAssigned)) {
        acc.assignAllSchools.push(courseId);
      } else if (!acc.assignSchools[ courseId ]) {
        acc.assignSchools[courseId] = schoolsAssigned;
      }
      return acc;
    }, {
      assignAllSchools: [],
      assignSchools: {}
    });
    const {
      unassignAllSchools,
      unassignSchools
    } = _.reduce(unAssignedSchools, (acc, courseId) => {
      const schoolsUnAssigned = this.metaData.entitler.schoolMappingDeleted[courseId] || [];
      if (this.coversAllEnabledSchools(courseId, schoolsUnAssigned)) {
        acc.unassignAllSchools.push(courseId);
      } else if (!acc.unassignSchools[courseId]) {
        acc.unassignSchools[courseId] = schoolsUnAssigned;
      }
      return acc;
    }, {
      unassignAllSchools: [],
      unassignSchools: {}
    });
    return {
      assignSchools,
      unassignSchools,
      assignAllSchools,
      unassignAllSchools
    };
  }

  submitSelections () {
    const missingMapping = this.metaData.entitler.rowIds.some(rowId => {
      return !this.metaData.entitler.schoolMappingCreated.hasOwnProperty(rowId) && !this.metaData.entitler.schoolMappingDeleted.hasOwnProperty(rowId);
    });
    if(missingMapping) {
      this.hasSelections = false;

    } else if (this.createValues.length !== 0 || this.deleteValues.length !== 0 || this.checkForSchoolFilterUpdates()){
      const {
        assignSchools,
        unassignSchools,
        assignAllSchools,
        unassignAllSchools
      } = this.buildSchoolAssignments();
      let request = {
        assignSchools,
        unassignSchools,
        assignAllSchools,
        unassignAllSchools,
        type: this.tabName,
        assign: this.createValues,
        unassign: this.deleteValues,
        productAssignmentId: this.entitler.selectedProducts[0].id,
        aleksMasterTemplateId: this.doesEntitlerHaveSelectedAleksMasterTemplate() ? this.entitler.selectedAleksMasterTemplate[0].aleksMasterTemplateId : null,
        // same crash-safety fix as fetchDataForActiveTab() above
        // - use getSelectedResourceId() instead of a direct
        // `selectedResources[0].id` read.
        enterpriseResourceId: this.getSelectedResourceId(),
        manageLicenses: this.isManagedLicensesEnabled(),
      };

      this.entitlerService.updateProductsAssociations(request)
        .then(this.onUpdateProductAssociationsSuccess.bind(this),
          this.onUpdateProductAssociationsFailure.bind(this));

    } else {
      this.hasSelections = false;
    }
  }

  onUpdateProductAssociationsSuccess(response) {
    let tabName = this.tabName;
    let sourceKey = this.tabName === 'courses' ? 'courseId' : this.tabName === 'classes' ? 'classId' : 'userId';
    const content = _.map(this.data.content, (row) => {
      return {
        id: row.id,
        name: row.name,
        sourceId: row[sourceKey]
      };
    });
    if (response && response.data && response.data.content && response.data.content.message === 'Enrollments Updated') {
      this.error = false;
      this.entitler.isProductsAssignmentSuccessful = true;
      this.entitler.schoolMappingUpdated = this.metaData.entitler.schoolMappingCreated || this.metaData.entitler.schoolMappingDeleted;
      this.entitler.addedAssociations = _.filter(content, (row) => _.includes(this.createValues, row.id));
      this.entitler.removedAssociations = _.filter(content, (row) => _.includes(this.deleteValues, row.id));
      this.entitler.createValues = this.createValues;
      this.entitler.deleteValues = this.deleteValues;
      this.entitler.schoolMapping = {
        creates: this.metaData.entitler.schoolMappingCreated,
        deletes: this.metaData.entitler.schoolMappingDeleted
      };
      this.entitler.updatedProducts = response.data.content.updatedProducts;
      this.entitler.noSEProductAvailable = response.data.content.noSEProductAvailable;
      this.entitler.manageLicenses = this.isManagedLicensesEnabled();
      this.entitler.currentTab = this.tabName;
      this.$state.go('home.assign.confirmation', {
        tabName: tabName
      });
    }
  }

  onUpdateProductAssociationsFailure() {
    this.error = true;
  }

  goToPreviousState() {
    this.entitler.selectedAleksMasterTemplate = [];
    if (this.doesEntitlerHaveSelectedResources() && !this.entitler.isResourcesAutoAssigned) {
      this.$state.go('home.assign.resourceSelector');
    } else {
      this.$state.go('home.assign.productsSelector');
    }
  }

  getNextSetOfRowsToFetch() {
    this.fetchDataForActiveTab(this.offset, this.tabName);
  }

  onRequestRetrievalSuccess(successResponse) {
    let contentWithSelected = this.initializeSelected(successResponse.data.content.data);
    let contentWithSelectedAndDisabled = this.initializeDisabled(contentWithSelected);
    this.updatedContent = this.previousData.content.concat(contentWithSelectedAndDisabled);
    let updatedData = {
      content: this.updatedContent
    };
    this.getStudentPersistValue(updatedData);
    this.metaData.persistStudentValue = this.persistStudentValue;
    this.metaData.customerId = this.userId;
    this.data = updatedData;
    this.previousData = this.data;
    this.offset += this.ROWS_PER_PAGE;
    this.metaData.entitler.search.errors.NO_SEARCH_RESULTS = this.data.content.length === 0 ? true : false;
  }
  getStudentPersistValue(courseData) {
    if(this.activeTab.options.tabName === 'courses'){
      let persistValue = this.assignmentsService.getPersistValueFromLocalStorage(this.userId);
      if (persistValue) {
        this.persistStudentValue = persistValue;
        return;
      }
      let preferenceStudent = courseData.content.find(
        (item) => item.schoolIds.length > 0
      );
      this.persistStudentValue = preferenceStudent ? preferenceStudent.schoolIds : null;
      preferenceStudent && this.assignmentsService.setPersistValueToLocalStorage(
        this.userId,
        this.persistStudentValue
      );
    }
  }

  initializeDisabled(content) {
    let disabledItems = [];
    // check if selected template is expired or archived
    const selectedTemplate = this.doesEntitlerHaveSelectedAleksMasterTemplate() ? this.entitler.selectedAleksMasterTemplate[0] : null;
    const isTemplateExpired = selectedTemplate && selectedTemplate.endDate && moment().isAfter(moment(selectedTemplate.endDate));
    const isTemplateArchived = selectedTemplate && selectedTemplate.isArchived;
    const isTemplateUnavailable = isTemplateExpired || isTemplateArchived;

    // here we need to add the new flag
    _.each(content, (row) => {
      row.isSecondaryProduct = this.isSelectedProductCategorySecondary();
      if (row.isCourseAssigned) {
        row.isDisabled = true;
        row.toolTip = 'This is assigned at course level';
      } else if (row.isSectionAssigned) {
        row.isDisabled = true;
        row.toolTip = 'This is assigned at class level';
      } else if (row.productAssignmentType === 'OR') {
        row.isDisabled = true;
        row.isReadOnly = !(row.isAssigned || row.isCourseAssigned || row.isSectionAssigned);
        row.toolTip = 'This is assigned via resources.';
      } else if (row.hasAssociationRestriction) {
        row.isDisabled = true;
        row.isReadOnly = !(row.isAssigned || row.isCourseAssigned || row.isSectionAssigned);
        row.toolTip = this.isSelectedProductCategorySecondary() ? 'An appropriate primary product must be assigned to assign the selected product.' : 'The linked secondary product must be unassigned prior to unassigning this primary product';
      } else if (!row.assignmentEnabled) {
        row.isDisabled = true;
        row.isReadOnly = !(row.isAssigned || row.isCourseAssigned || row.isSectionAssigned);
        row.toolTip = row.aleksMasterTemplateId ? 'This is already assigned to Aleks Master Template '+ row.aleksMasterTemplateId + ' for ' + row.resourceName : 'This is already assigned to '+ row.resourceName;
      } else if (isTemplateUnavailable && !(row.isAssigned || row.isCourseAssigned || row.isSectionAssigned)) {//PR 1076 deploying changes to qastg
        // disable if template is expired/archived AND row is NOT already assigned
        row.isDisabled = true;
        row.isReadOnly = true;
        row.toolTip = isTemplateExpired && isTemplateArchived ? 'Cannot assign expired & archived template. Unassign existing assignments if needed.' :
          isTemplateExpired ? 'Cannot assign expired template. Unassign existing assignments if needed.' :
            'Cannot assign archived template. Unassign existing assignments if needed.';
      }
      disabledItems.push(row);
    });

    return disabledItems;
  }

  initializeSelected(content) {
    let updatedSelected = [];
    _.each(content, (row) => {
      let created = this.createValues.indexOf(row.id) >= 0;
      let deleted = this.deleteValues.indexOf(row.id) >= 0;
      if (row.isAssigned || row.isCourseAssigned || row.isSectionAssigned) {
        if (deleted) {
          row.isCreated = false;
          row.isDeleted = true;
          row.isSelected = false;
        } else {
          row.isCreated = false;
          row.isDeleted = false;
          row.isSelected = true;
        }
      } else {
        if (created) {
          row.isCreated = true;
          row.isDeleted = false;
          row.isSelected = true;
        } else {
          row.isCreated = false;
          row.isDeleted = false;
          row.isSelected = false;
        }
      }
      if (row.isSelected) {
        updatedSelected.push(row.id);
      }
    });
    updatedSelected = updatedSelected.concat(this.selectedValues);
    angular.copy(_.uniq(updatedSelected), this.selectedValues);
    //if(_.size(this.selectedValues) === _.size(content))
    return content;
  }

  updateChangedAndSelected() {
    let updatedSelected = [];
    let updatedCreated = [];
    let updatedDeleted = [];
    let removeCreated = [];
    let removeDeleted = [];
    _.each(this.data.content, (row) => {

      let selected = this.selectedValues.indexOf(row.id) >= 0;
      if ((row.isAssigned || row.isCourseAssigned || row.isSectionAssigned)) {
        if (selected) {
          row.isCreated = false;
          row.isDeleted = false;
          row.isSelected = true;
        } else {
          row.isCreated = false;
          row.isDeleted = true;
          row.isSelected = false;
        }
      } else {
        if (selected) {
          row.isCreated = true;
          row.isDeleted = false;
          row.isSelected = true;
        } else {
          row.isCreated = false;
          row.isDeleted = false;
          row.isSelected = false;
        }
      }

      if (row.isCreated) {
        removeDeleted.push(row.id);
        updatedCreated.push(row.id);
      } else {
        removeCreated.push(row.id);
      }
      if (row.isDeleted) {
        removeCreated.push(row.id);
        updatedDeleted.push(row.id);
      } else {
        removeDeleted.push(row.id);
      }
      if (row.isSelected) {
        updatedSelected.push(row.id);
      }
    });

    _.remove(this.createValues, (value) => {
      return removeCreated.indexOf(value) >= 0;
    });

    _.remove(this.deleteValues, (value) => {
      return removeDeleted.indexOf(value) >= 0;
    });

    angular.copy(_.uniq(updatedSelected), this.selectedValues);

    updatedCreated = updatedCreated.concat(this.createValues);
    angular.copy(_.uniq(updatedCreated), this.createValues);

    updatedDeleted = updatedDeleted.concat(this.deleteValues);
    angular.copy(_.uniq(updatedDeleted), this.deleteValues);
  }

  onRequestRetrievalFailure() {}

  toggleSort(columnName, descendingFlag) {
    let tabName = this.tabName;
    this.setSortOrderAndColumn(columnName, descendingFlag);
    this.resetPaginationDefaults();

    // here making sure the order of calls r maintained. So that cousre assignment UI is only build after the schoolList is recieved
    if (tabName === 'courses' && this.schoolList.length === 0) {
      this.fetchOrgForCustomer().then(() => {
        this.fetchDataForActiveTab(this.offset, tabName);
      });
    } else {
      this.fetchDataForActiveTab(this.offset, tabName);
    }
  }

  toggleHeaderCheckbox(columnName, selectAllFlag) {
    if (selectAllFlag) {
      angular.copy(_.map(_.reject(this.data.content, (item) => item.isReadOnly), 'id'), this.selectedValues);
    } else {
      //filter the disabled items while deselect all.
      angular.copy(_.reduce(this.data.content, (result, item) => {
        if (item.isDisabled && !item.isReadOnly) {
          result.push(item.id);
        }
        return result;
      }, []), this.selectedValues);
    }
  }

  setSortOrderAndColumn(columnName, descendingFlag) {
    let columnInfo = _.find(this.activeTab.columns, (columnData) => {
      if (columnData.name === columnName) {
        return columnData;
      }
    });
    this.sortBy.column = columnInfo && columnInfo.sortAlias ? columnInfo.sortAlias : columnName;
    this.sortBy.order = descendingFlag ? this.sort.descending : this.sort.ascending;
  }

  resetPaginationDefaults() {
    this.offset = 0;
    this.previousData = {
      content: []
    };
  }

  search() {
    let tabName = this.tabName;
    this.searchValue = this.metaData.entitler.search.value;
    this.resetPaginationDefaults();
    this.fetchDataForActiveTab(this.offset, tabName);
  }

  /**
   *  This method is called once when all child elements are linked,
   *  Thus here we know what product is selected and can compile the tabs elements accordingly
   */
  $postLink() {
    const selectedProduct = this.entitler.selectedProducts.length !== 0 ? this.entitler.selectedProducts[0] : null;
    const selectedProductPlatform = selectedProduct && selectedProduct.platform ? selectedProduct.platform.toLowerCase() : null;
    //change the tab items, if the selected product in not ConnectEd and not set.
    if (selectedProductPlatform !== 'connected' && selectedProductPlatform !== null) {
      this.tabs = this.getTabsForNoneConnectedProducts();
    }
  }
}

AssignmentsController.$inject = ['modalLoaderService', '$state', 'entitlerService', '$translate', '$scope', 'localStorageService', '$q', 'assignmentsService'];

export
default AssignmentsController;



// WEBPACK FOOTER //
// ./app/components/assignments/assignments.controller.js